import './aboutus.css';
import * as React from 'react'
import {Component} from "react";
import {setActiveMenuItem, setLogoWhite, setNavbarTheme} from "../../util";
import {Header} from "../../widgets";


export class AboutUS extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isPhone: window.innerWidth < 1000
        }
    }

    componentDidMount() {
        setNavbarTheme('#040f2b');
        setActiveMenuItem('om_oss', window.innerWidth < 1000);
        setLogoWhite(false);

        const self = this;

        window.matchMedia('(min-width: 1000px').addEventListener('change', () => {
            self.setState({isPhone: window.innerWidth < 1000});
        });
    }

    render() {
        return (
            <div>
                {this.renderAboutUs()}
            </div>
        )
    }

    renderAboutUs() {
        if(this.state.isPhone) {
            return (
                <div className={'default-large-cage default-vertical-cage about-us-phone'}>
                    <div className={'about-us-phone-1'}>
                        <div className={'default-center'}>
                            <img src={'resources/blonomSustainability.png'}/>
                        </div>
                        <Header text={'Produktet'}/>
                        <p className={'about-us-phone-text'}>Produktet vårt er et tørrstoffprodukt av fiskeblod som inneholder store mengder med næringsstoffer som protein og hemoglobin. Vi ønsker med dette produktet å bidra til lett tilgang på næringsstoffer til dyr.  </p>
                    </div>
                    <div className={'about-us-phone-2'}>
                        <div className={'default-center'}>
                            <img src={'resources/blonomProduct.png'}/>
                        </div>
                        <Header text={'Bærekraft'}/>
                        <p className={'about-us-phone-text'}>Blonom ønsker å skape verdi hvor det ikke er verdi i dag. I dag er blod fra fisk et restråstoff man ikke ser særlig nytte i og man bruker ressurser for å kvitte seg med det. Vår ide er å lage et tørrstoffprodukt av lakseblod. Vi har som mål å være en bidragsyter når det kommer til et bærekraftig Norge. </p>
                    </div>
                </div>
            )
        } else {
            return (
                <div className={'default-large-cage default-vertical-cage'}>
                    <div className={'about-us'}>
                        <div className={'about-us-component-1-container'}>
                            <div className={'about-us-component-1'}>
                                <p className={'about-us-component-1-header'}>Produktet</p>
                                <div className={'text-container'}>
                                    <p className={'about-us-component-1-text'}>Produktet vårt er et tørrstoffprodukt av fiskeblod som inneholder store mengder med næringsstoffer som protein og hemoglobin. Vi ønsker med dette produktet å bidra til lett tilgang på næringsstoffer til dyr. </p>
                                </div>
                                <div className={'image-container-1'}>
                                    <img src={'resources/blonomSustainability.png'}/>
                                </div>
                            </div>
                        </div>
                        <div className={'about-us-component-2-container'}>
                            <div className={'about-us-component-2'}>
                                <p className={'about-us-component-2-header'}>Bærekraft</p>
                                <div className={'text-container'}>
                                    <p className={'about-us-component-2-text'}>Blonom ønsker å skape verdi hvor det ikke er verdi i dag. I dag er blod fra fisk et restråstoff man ikke ser særlig nytte i og man bruker ressurser for å kvitte seg med det. Vår ide er å lage et tørrstoffprodukt av lakseblod. Vi har som mål å være en bidragsyter når det kommer til et bærekraftig Norge.  </p>
                                </div>
                                <div className={'image-container-2'}>
                                    <img src={'resources/blonomProduct.png'}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }
}